import routes from './routes';
import { SetRoutes } from 'components';

const SalesTrackingsGenderAgePages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default SalesTrackingsGenderAgePages;
